<template>
  <v-form v-model="$storeUniversite.validProg" ref="formulaireProgramme" lazy-validation>
    <div class="stepper-container">
      <br/>
      <v-row>
        <v-col cols="12" md="6">
          <v-autocomplete dense v-model="$storeUniversite.inscription.ChoixCycle" :items="$storeUniversite.ChoixCycle"
            :item-text="$storeUniversite.itemLang" item-value="id" :label="$storeUniversite.label.ChoixCycle" outlined
            :rules="[$rules.obligatoire()]" class="asterisk" @change="ChoixCycleChange();" :disabled="$storeUniversite.inscription.ReadOnlyProgrammes ||
              $storeUniversite.inscription.Etat !=
              $storeCatalogue.DataId.InscriptionIncomplete
              "></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <v-autocomplete dense v-model="$storeUniversite.inscription.NiveauDEtude"
            :items="$storeUniversite.NiveauEtude" :item-text="$storeUniversite.itemLang" item-value="id"
            :label="$storeUniversite.label.ChoixDiplome" outlined multiple :rules="[$rules.arrayObligatoire()]"
            class="asterisk" @change="$storeUniversite.GetNiveauDiplome($storeCatalogue);NiveauDEtudeChange()" :readonly="$storeUniversite.inscription.ReadOnlyProgrammes ||
              $storeUniversite.inscription.Etat !=
              $storeCatalogue.DataId.InscriptionIncomplete
              "></v-autocomplete>
        </v-col>
      </v-row>
      <!-- Boucle par niveau -->
      <div
      v-for="niveau in VueProgramme"
      :key="'niv_'+niveau.niveau.id">
        <div
          v-if="
            $storeUniversite.inscription.NiveauDEtude.indexOf(
              niveau.niveau.id
            ) >= 0
          "
        >
          <h2>
            {{
              $StoreAnnexesInscrUm6p.ItemLang == "Lang00"
                ? niveau.niveau.lang00
                : niveau.niveau.lang01
            }}
          </h2>
          <!-- Boucle par cluster -->
          <div v-for="cluster in niveau.programmes" :key="'cluster_'+cluster[0].idCrypte">
            <h3 v-if="$storeUniversite.inscription.NiveauDEtude.indexOf(
              niveau.niveau.id
            ) >= 0">
            
              {{
                $StoreAnnexesInscrUm6p.ItemLang == "Lang00"
                  ? cluster[0].cluster.lang00
                  : cluster[0].cluster.lang01
              }}
            </h3>
            <small
            style="font-weight: 700;color:#004A99"
            v-if="cluster[0].cluster.id === $storeCatalogue.DataId.ClusterSante 
            && niveau.niveau.id === $storeCatalogue.DataId.PostBac">
            {{ $storeUniversite.label.MedecinePharmacie1 }}
            </small>
            <small style="color:#004A99;text-decoration: underline;" v-if="cluster[0].cluster.id === $storeCatalogue.DataId.ClusterSante 
            && niveau.niveau.id === $storeCatalogue.DataId.PostBac">
            {{ $storeUniversite.label.MedecinePharmacie2 }}
            </small>
            <v-list>
              <!-- Boucle par programme -->
              <v-list-item-group
                v-for="program in 
                  cluster
                  .filter(p => 
                    ($storeUniversite.inscription.NiveauDEtude.indexOf(niveau.niveau.id) >= 0 && !p.programmeSportif) 
                    || (p.programmeSportif 
                        && $storeUniversite.inscription.SportifHautNiveau == $storeCatalogue.DataId.Oui))"
                :key="'prog_'+program.idCrypte"
              >
                <span>{{ program.ecole }}</span>
                <v-checkbox
                  dense
                  v-model="program.isChecked"
                  :disabled="
                    program.readOnly ||
                    ($storeUniversite.inscription.Etat !=
                      $storeCatalogue.DataId.InscriptionIncomplete &&
                      program.idProgramme !== undefined)
                  "
                  @change="ProgramIsCheckedChange(program)"
                >
                  <template v-slot:label>
                    <div>
                      {{ program.label }}
                      <!-- Texte rouge  -->
                      <div
                        class="red--text dateFermeture"
                        v-if="program.dateFermetureAffichee != null"
                      >
                        {{ $storeUniversite.label.DateFermeture }}
                        {{ FormatDate(program.dateFermetureAffichee) }}
                        <br/>
                        <span v-if="program.minimumSpecialite>0 && program.maximumSpecialite">
                          {{ $storeUniversite.label.MerciSelectionner }} {{ program.minimumSpecialite }} {{ $storeUniversite.label.Et }} {{ program.maximumSpecialite }} {{ $storeUniversite.label.Specialites }}
                        </span>
                        <span v-else-if="program.minimumSpecialite>0">
                          {{ $storeUniversite.label.MerciSelectionnerAuMoins }} {{ program.minimumSpecialite }} {{ $storeUniversite.label.Specialites }}
                        </span>
                        <span v-else-if="program.maximumSpecialite">
                          {{ $storeUniversite.label.MerciSelectionnerAuMaximum }} {{ program.maximumSpecialite }} {{ $storeUniversite.label.Specialites }}
                        </span>
                      </div>
                    </div>
                  </template>
                  
                </v-checkbox>
                <!-- checkbox spécialités -->
                <div v-if="program.listeSpecialites.length > 0 && program.isChecked === true" 
                class="bloc-specialites">
                    <h5>{{ $storeUniversite.label.ListeSpecialite }}</h5>
                    <div v-for="specialite in program.listeSpecialites" :key="'spec_'+specialite.idCrypte">
                    <v-checkbox
                    dense
                    :label="specialite.label"
                    v-model="specialite.isChecked"
                    :disabled="
                      program.readOnly ||
                      ($storeUniversite.inscription.Etat !=
                        $storeCatalogue.DataId.InscriptionIncomplete &&
                        specialite.idSpecialite !== undefined)
                        || (!specialite.isChecked && MaximumSpecialites(program))
                    "
                    @change="SpecialiteIsCheckedChange(program, specialite)"
                    />
                  </div>
                </div>
                <!-- Dragndrop spécialités -->
                <div
                v-if="program.listeSpecialitesVue.length>0"
                class="selected-programs bloc-specialites">
                  <h5>Organisez votre liste : Glissez-déposez les spécialités pour les trier selon votre préférence.</h5>
                  <draggable
                  :list="program.listeSpecialitesVue"
                  :disabled="
                    $storeUniversite.inscription.Etat !==
                      $storeCatalogue.DataId.InscriptionIncomplete &&
                    $storeUniversite.inscription.Etat !=
                      $storeCatalogue.DataId.InscriptionR1 &&
                    $storeUniversite.inscription.Etat !=
                      $storeCatalogue.DataId.InscriptionR2
                  "
                  class="list-group"
                  ghost-class="ghost"
                  @start="DraggingSpecialites = true"
                  @end="UpdateOrderSpecialites(program)">
                    <div
                      class="list-group-item"
                      v-for="specialite in program.listeSpecialitesVue"
                      :key="'drag_spec_'+specialite.idCrypte"
                    >
                      {{
                        $storeUniversite.label.ChoixProg +
                        " " +
                        specialite.noOrdre +
                        " : " +
                        specialite.label
                      }}
                    </div>
                  </draggable>
                  <br/>
                </div>
              </v-list-item-group>
            </v-list>
          </div>
        </div>
      </div>
      <!-- Drag n drop programmes -->
      <div
        class="selected-programs"
        v-if="ListeProgrammesSelectionnes.length>0"
      >
        <h3>{{ $storeUniversite.label.TitreListeProgs }}</h3>
        <h5>{{ $storeUniversite.label.NoteListeProgrs }}</h5>
        <br />
        <draggable
        :list="ListeProgrammesSelectionnes"
        :disabled="
          $storeUniversite.inscription.Etat !==
            $storeCatalogue.DataId.InscriptionIncomplete &&
          $storeUniversite.inscription.Etat !=
            $storeCatalogue.DataId.InscriptionR1 &&
          $storeUniversite.inscription.Etat !=
            $storeCatalogue.DataId.InscriptionR2
        "
        class="list-group"
        ghost-class="ghost"
        @start="DraggingProgrammes = true"
        @end="UpdateOrderProgramme()"
        >
          <div
            class="list-group-item"
            v-for="program in ListeProgrammesSelectionnes"
            :key="'drag_prog_'+program.idCrypte"
          >
            {{
              $storeUniversite.label.ChoixProg +
              " " +
              program.noOrdre +
              " : " +
              program.label
            }}
          </div>
        </draggable>
      </div>
    </div>
    <v-row>
      <span class="required">
        <span class="legend"></span>
      </span>
    </v-row>
    <br/>
  </v-form>
</template>
<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
  },
  data() {
    return {
      VueProgramme: [],
      ListeProgrammesSelectionnes: [],
      $storeUniversite: this.$storeUniversite,
      $storeCatalogue: this.$storeCatalogue,
      DraggingProgrammes: false,
      DraggingSpecialites: false,
    }
  },
  mounted(){
  },
  methods: {
    Valider() {
      let validation = this.$refs.formulaireProgramme.validate();

      // Vérifier si on moins un programme est sélectionné.
      if (
        this.$storeUniversite.inscription.ListeProgrammesUm6p.length < 1 &&
        !this.$storeUniversite.inscription.ReadOnly
      ) {
        validation = false;
      }

      // Vérifier le nombre minimum de spécialités sélectionnées.
      this.$storeUniversite.inscription.ListeProgrammesUm6p.forEach(programme=>{
        if(programme.minimumSpecialite>0 
          && programme.listeSpecialitesVue.length < programme.minimumSpecialite
        ){
          validation = false;
        }
      });

      return validation;
    },
    DeselectionnerProgrammeSportif(){
      this.VueProgramme.forEach(niveau => {
        for(let cluster in niveau.programmes){
          niveau.programmes[cluster].forEach(p=>{
            if(p.programmeSportif && p.isChecked){
              p.isChecked = false;
              this.ListeProgrammesSelectionnes = this.ListeProgrammesSelectionnes.filter(e=> e.idCrypte !== p.idCrypte);
            }
          })
        }
      });

      this.UpdateOrderProgramme();
    },
    MaximumSpecialites(programme){
      if(programme && programme.maximumSpecialite){
        return programme.listeSpecialitesVue.length === programme.maximumSpecialite;
      }
    },
    SpecialiteIsCheckedChange(programme, specialite){
      let lSpec = this.ListeProgrammesSelectionnes.find(e=> e.idCrypte == programme.idCrypte).listeSpecialitesVue;
      if(specialite.isChecked){
        if(!programme.listeSpecialitesVue.find(e=> e.idCrypte === specialite.idCrypte)){
          specialite.noOrdre = programme.listeSpecialitesVue.length+1;
          programme.listeSpecialitesVue.push(specialite);
        }
        if(!lSpec.find(e=> e.idCrypte === specialite.idCrypte)){
          specialite.noOrdre = lSpec.length+1;
          lSpec.push(specialite);
        }
      }
      else{
        programme.listeSpecialitesVue = programme.listeSpecialitesVue.filter(e=> e.idCrypte !== specialite.idCrypte);
        lSpec = lSpec.filter(e=> e.idCrypte !== specialite.idCrypte);
        this.UpdateOrderSpecialites(programme);
      }
      this.$storeUniversite.ShowBtnMajProgrammes = true;
    },
    UpdateOrderSpecialites(programme){
      programme.listeSpecialitesVue.forEach((item, index) => {
        // Pour garantir la réactivité, on peut utiliser Vue.set
        this.$set(item, "noOrdre", index + 1);
      });
      this.ListeProgrammesSelectionnes
      .find(e=> e.idCrypte == programme.idCrypte)
      .listeSpecialitesVue.forEach((item)=>{
        let specialite = programme.listeSpecialitesVue.find(e=> e.idCrypte == item.idCrypte);
        this.$set(item, "noOrdre", specialite.noOrdre);
      });
      this.$storeUniversite.ShowBtnMajProgrammes = true;
    },
    UpdateOrderProgramme(){
     this.ListeProgrammesSelectionnes.forEach((item, index) => {
        // Pour garantir la réactivité, on peut utiliser Vue.set
        this.$set(item, "noOrdre", index + 1);
      });
      this.$storeUniversite.ShowBtnMajProgrammes = true;
    },
    MajProgramme(idCrypte, isChecked){
      let programme = null;

      this.VueProgramme.forEach(niveau => {
        for(let cluster in niveau.programmes){
          niveau.programmes[cluster]
          .forEach(p=>{
            if(p.idCrypte === idCrypte){
              p.isChecked = isChecked;
              if(!isChecked){
                p.noOrdre = 100;
                p.listeSpecialites.forEach(s => s.isChecked = false);
                p.listeSpecialitesVue = [];
              }
              programme = p;
            }
          })
        }
      });
      return programme;
    },
    ProgramIsCheckedChange(programme){
      let programmeLie = null;
      if(programme.programmeLie){
        programmeLie = this.MajProgramme(programme.programmeLie, programme.isChecked);
      }

      // Si le programme est sélectionné.
      if(programme.isChecked){
        // Ajout du programme dans la liste des programmes Selectionnés (liste pour le dragndrop)
        if(!this.ListeProgrammesSelectionnes.find(e=> e.idCrypte === programme.idCrypte)){
          programme.noOrdre = this.ListeProgrammesSelectionnes.length+1;
          this.ListeProgrammesSelectionnes.push(programme);
        }

        // Sélectionner le programme lié.
        if(programme.programmeLie
          && programmeLie) {
          // Ajout du programme lié dans la liste des programmes Selectionnés (liste pour le dragndrop)
          if(!this.ListeProgrammesSelectionnes.find(e=> e.idCrypte === programmeLie.idCrypte)){
            programmeLie.noOrdre = this.ListeProgrammesSelectionnes.length+1;
            this.ListeProgrammesSelectionnes.push(programmeLie);
          }
        }
      } // Si le programme est désélectionné.
      else{
        // Retirer le programme de la liste des programmes sélectionnés + RAZ des spécialités et NoOrdre.
        if(this.ListeProgrammesSelectionnes.find(e=> e.idCrypte === programme.idCrypte)){
          programme.noOrdre = 100;
          programme.listeSpecialites.forEach(s => s.isChecked = false);
          programme.listeSpecialitesVue = [];
          this.ListeProgrammesSelectionnes = this.ListeProgrammesSelectionnes.filter(e=> e.idCrypte !== programme.idCrypte);
          this.UpdateOrderProgramme();
        }

        // Maj si un programme lié existe.
        if(programme.programmeLie
          && programmeLie) {
          // Retirer le programme de la liste des programmes sélectionnés + RAZ des spécialités et NoOrdre.
          if(this.ListeProgrammesSelectionnes.find(e=> e.idCrypte === programmeLie.idCrypte)){
            programmeLie.noOrdre = 100;
            programmeLie.listeSpecialites.forEach(s => s.isChecked = false);
            programmeLie.listeSpecialitesVue = [];
            this.ListeProgrammesSelectionnes = this.ListeProgrammesSelectionnes.filter(e=> e.idCrypte !== programmeLie.idCrypte);
            this.UpdateOrderProgramme();
          }
        }
      }

      this.$storeUniversite.ShowBtnMajProgrammes = true;
    },
    AffecterVueProgramme(){
      this.VueProgramme = this.$storeUniversite.ListeVueProgrammes;

      this.VueProgramme.forEach(niveau => {
        for(let cluster in niveau.programmes){
          niveau.programmes[cluster]
          .filter(p => p.isChecked)
          .forEach(p=>{
            if(!this.ListeProgrammesSelectionnes.find(e=> e.idCrypte === p.idCrypte)){
              this.ListeProgrammesSelectionnes.push(p);
            }
          })
        }
      });
      this.ListeProgrammesSelectionnes = this.ListeProgrammesSelectionnes.sort((a, b) => Number(a.noOrdre) - Number(b.noOrdre));
    },
    AffecterStore(){
      this.$storeUniversite.inscription.ListeProgrammesUm6p = this.ListeProgrammesSelectionnes;
    },
    NiveauDEtudeChange(){
        // Déselectionner les programmes et spécialités.
        this.VueProgramme.forEach(niveau => {
        for(let cluster in niveau.programmes){
          niveau.programmes[cluster].forEach(p=>{
            if(p.isChecked && this.$storeUniversite.inscription.NiveauDEtude.indexOf(p.niveauEtude)<0){
              p.isChecked = false;
              p.listeSpecialitesVue = [];
              p.listeSpecialites.forEach(specialite=>{
                if(specialite.isChecked){
                  specialite.isChecked = false;
                }
              });
              this.ListeProgrammesSelectionnes = this.ListeProgrammesSelectionnes.filter(e=> e.idCrypte !== p.idCrypte);
            }
          })
        }
      });
    },
    ChoixCycleChange() {
      if (
        this.$storeUniversite.inscription.ReadOnly ||
        this.$storeUniversite.inscription.Etat !=
        this.$storeCatalogue.DataId.InscriptionIncomplete
      ) {
        this.$storeUniversite.NiveauEtude = this.$storeCatalogue.Diplomes;
      } 
      else {
        // Déselectionner les programmes et spécialités.
        this.ListeProgrammesSelectionnes = [];
        // Changer les cycles.
        if (this.$storeUniversite.inscription.ChoixCycle == this.$storeCatalogue.DataId.CyclePostBac
        ) {
          this.$storeUniversite.inscription.NiveauDEtude = [
            this.$storeCatalogue.DataId.PostBac,
          ];
          this.$storeUniversite.NiveauEtude =
            this.$storeUniversite.NiveauEtudeFixeSoumission.filter(
              (item) => item.id == this.$storeCatalogue.DataId.PostBac
            );
        } else if (
          this.$storeUniversite.inscription.ChoixCycle ==
          this.$storeCatalogue.DataId.CycleMasterInge
        ) {
          this.$storeUniversite.NiveauEtude =
            this.$storeUniversite.NiveauEtudeFixeSoumission.filter(
              (item) =>
                item.id == this.$storeCatalogue.DataId.ProgrammeIngenieur ||
                item.id == this.$storeCatalogue.DataId.ProgrammeParallele ||
                item.id == this.$storeCatalogue.DataId.ProgrammeParalleleBac1 ||
                item.id == this.$storeCatalogue.DataId.Master
            );
          this.$storeUniversite.inscription.NiveauDEtude =
            this.$storeUniversite.inscription.NiveauDEtude.filter(
              (item) => item != this.$storeCatalogue.DataId.PostBac
            );
        }
      }

      this.NiveauDEtudeChange();
    },
    FormatDate(date) {
      if (!date) return null;

      let [year, month, dayTime] = date.split("-");
      let [day, time] = dayTime.split("T");

      // Gestion de l'heure et des minutes
      let formattedTime = "";
      if (time) {
        let [hour, minute] = time.split(":");
        formattedTime = ` ${hour}:${minute}`;
      }

      return `${day}/${month}/${year}${formattedTime}`;
    },
  },
}
</script>
<style scoped>
@import "../../assets/css/InscriptionUniversite.css";
</style>